module.exports = __webpack_public_path__ + "static/media/festive.95e13513.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/festive.png
// module id = 704
// module chunks = 0